// extracted by mini-css-extract-plugin
export var discard = "_3u-3";
export var muiTooltipTooltip = "_3u-5";
export var notificationBar = "_3u-2";
export var saveButtonHoverSlotWrapper = "_3u-4";
export var show = "_3u-1";
export var spacer = "_3u-0";